"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLTFLoader = exports.GLTF_EXTENSIONS = void 0;
const viewer_rendering_engine_camera_engine_1 = require("@shapediver/viewer.rendering-engine.camera-engine");
const viewer_rendering_engine_light_engine_1 = require("@shapediver/viewer.rendering-engine.light-engine");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const gl_matrix_1 = require("gl-matrix");
const AccessorLoader_1 = require("./loaders/AccessorLoader");
const BufferLoader_1 = require("./loaders/BufferLoader");
const BufferViewLoader_1 = require("./loaders/BufferViewLoader");
const GeometryLoader_1 = require("./loaders/GeometryLoader");
const MaterialLoader_1 = require("./loaders/MaterialLoader");
const TextureLoader_1 = require("./loaders/TextureLoader");
var GLTF_EXTENSIONS;
(function (GLTF_EXTENSIONS) {
    GLTF_EXTENSIONS["KHR_BINARY_GLTF"] = "KHR_binary_glTF";
    GLTF_EXTENSIONS["KHR_DRACO_MESH_COMPRESSION"] = "KHR_draco_mesh_compression";
    GLTF_EXTENSIONS["KHR_LIGHTS_PUNCTUAL"] = "KHR_lights_punctual";
    GLTF_EXTENSIONS["KHR_MATERIALS_CLEARCOAT"] = "KHR_materials_clearcoat";
    GLTF_EXTENSIONS["KHR_MATERIALS_IOR"] = "KHR_materials_ior";
    GLTF_EXTENSIONS["KHR_MATERIALS_PBRSPECULARGLOSSINESS"] = "KHR_materials_pbrSpecularGlossiness";
    GLTF_EXTENSIONS["KHR_MATERIALS_SHEEN"] = "KHR_materials_sheen";
    GLTF_EXTENSIONS["KHR_MATERIALS_SPECULAR"] = "KHR_materials_specular";
    GLTF_EXTENSIONS["KHR_MATERIALS_TRANSMISSION"] = "KHR_materials_transmission";
    GLTF_EXTENSIONS["KHR_MATERIALS_UNLIT"] = "KHR_materials_unlit";
    GLTF_EXTENSIONS["KHR_MATERIALS_VARIANTS"] = "KHR_materials_variants";
    GLTF_EXTENSIONS["KHR_MATERIALS_VOLUME"] = "KHR_materials_volume";
    GLTF_EXTENSIONS["KHR_MESH_QUANTIZATION"] = "KHR_mesh_quantization";
    GLTF_EXTENSIONS["KHR_TEXTURE_TRANSFORM"] = "KHR_texture_transform";
    GLTF_EXTENSIONS["SHAPEDIVER_MATERIALS_PRESET"] = "SHAPEDIVER_materials_preset";
    GLTF_EXTENSIONS["EXT_MESH_GPU_INSTANCING"] = "EXT_mesh_gpu_instancing";
})(GLTF_EXTENSIONS || (exports.GLTF_EXTENSIONS = GLTF_EXTENSIONS = {}));
class GLTFLoader {
    constructor() {
        // #region Properties (22)
        this.BINARY_EXTENSION_HEADER_LENGTH = 20;
        this._eventEngine = viewer_shared_services_1.EventEngine.instance;
        this._globalTransformation = gl_matrix_1.mat4.fromValues(1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1);
        this._httpClient = viewer_shared_services_1.HttpClient.instance;
        this._logger = viewer_shared_services_1.Logger.instance;
        this._performanceEvaluator = viewer_shared_services_1.PerformanceEvaluator.instance;
        this._progressUpdateLimit = 500;
        this._uuidGenerator = viewer_shared_services_1.UuidGenerator.instance;
        this._matrixPool = [];
        this._nodeBatchSize = 100;
        this._vec3Pool = [];
        this._vec4Pool = [];
        this._eventId = "";
        this._nodes = {};
        this._numberOfConvertedNodes = 0;
        this._numberOfNodes = 0;
        this._progressTimer = 0;
        // #endregion Private Methods (7)
    }
    // #endregion Properties (22)
    // #region Public Methods (2)
    load(content, gltfBinary, gltfHeader, baseUri, taskEventId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this._eventId = taskEventId || this._uuidGenerator.create();
            const eventStart = {
                type: viewer_shared_types_1.TASK_TYPE.GLTF_CONTENT_LOADING,
                id: this._eventId,
                progress: 0,
                status: "Starting glTF 2.0 loading.",
            };
            this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_START, eventStart);
            this._numberOfConvertedNodes = 0;
            this._numberOfNodes = content.nodes ? content.nodes.length : 0;
            this._progressTimer = performance.now();
            this._baseUri = baseUri;
            if (gltfBinary && gltfHeader)
                this._body = gltfBinary.slice(this.BINARY_EXTENSION_HEADER_LENGTH +
                    gltfHeader.contentLength +
                    8, gltfHeader.length);
            this._content = content;
            this.validateVersionAndExtensions();
            // Lazy load DRACO module and parallelize independent loaders
            const { default: DRACO } = (yield Promise.resolve().then(() => __importStar(require("./draco/draco_decoder.js"))));
            const dracoModulePromise = new DRACO();
            this._bufferLoader = new BufferLoader_1.BufferLoader(this._content, this._body, this._baseUri);
            const bufferLoadPromise = this._bufferLoader.load();
            // Wait for buffers, then parallelize texture and material loading
            yield bufferLoadPromise;
            this._bufferViewLoader = new BufferViewLoader_1.BufferViewLoader(this._content, this._bufferLoader);
            this._bufferViewLoader.load();
            this._accessorLoader = new AccessorLoader_1.AccessorLoader(this._content, this._bufferViewLoader);
            this._accessorLoader.load();
            // Parallelize texture loading and DRACO module initialization
            this._textureLoader = new TextureLoader_1.TextureLoader(this._content, this._bufferViewLoader, this._baseUri);
            const [dracoModule] = yield Promise.all([
                dracoModulePromise,
                this._textureLoader.load(),
            ]);
            this._materialLoader = new MaterialLoader_1.MaterialLoader(this._content, this._textureLoader);
            yield this._materialLoader.load();
            this._geometryLoader = new GeometryLoader_1.GeometryLoader(this._content, this._accessorLoader, this._bufferViewLoader, this._materialLoader, dracoModule);
            const eventProgressInit = {
                type: viewer_shared_types_1.TASK_TYPE.GLTF_CONTENT_LOADING,
                id: this._eventId,
                progress: 0.1,
                status: "Initial logic of glTF loading.",
            };
            this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_PROCESS, eventProgressInit);
            const node = yield this.loadScene();
            if (this._content.extensions &&
                this._content.extensions[GLTF_EXTENSIONS.KHR_MATERIALS_VARIANTS]) {
                const variants = this._content.extensions[GLTF_EXTENSIONS.KHR_MATERIALS_VARIANTS]
                    .variants;
                for (let i = 0; i < variants.length; i++)
                    this._geometryLoader.materialVariantsData.variants.push(variants[i].name);
                this._geometryLoader.materialVariantsData.variantIndex = 0;
                node.data.push(this._geometryLoader.materialVariantsData);
            }
            if (this._content.animations)
                for (let i = 0; i < ((_a = this._content.animations) === null || _a === void 0 ? void 0 : _a.length); i++)
                    node.data.push(this.loadAnimation(i));
            const eventEnd = {
                type: viewer_shared_types_1.TASK_TYPE.GLTF_CONTENT_LOADING,
                id: this._eventId,
                progress: 1,
                status: "GlTF loading complete.",
            };
            this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_END, eventEnd);
            // Clean up resources that are no longer needed
            this._geometryLoader.cleanup();
            return node;
        });
    }
    loadWithUrl(url) {
        return __awaiter(this, void 0, void 0, function* () {
            this._performanceEvaluator.startSection("gltfProcessing." + url);
            this._performanceEvaluator.startSection("loadGltf." + url);
            const axiosResponse = (yield this._httpClient.get(url, {
                responseType: "arraybuffer",
            }));
            this._performanceEvaluator.endSection("loadGltf." + url);
            let gltfContent, gltfBinary, gltfBaseUrl, gltfHeader;
            const magic = new TextDecoder().decode(new Uint8Array(axiosResponse.data, 0, 4));
            const isBinary = magic === "glTF" ||
                (axiosResponse.headers["content-type"] &&
                    (axiosResponse.headers["content-type"] ===
                        "model/gltf-binary" ||
                        axiosResponse.headers["content-type"] ===
                            "application/octet-stream" ||
                        axiosResponse.headers["content-type"] ===
                            "model/gltf.binary"));
            if (isBinary) {
                gltfBinary = axiosResponse.data;
                // create header data
                const headerDataView = new DataView(gltfBinary, 0, this.BINARY_EXTENSION_HEADER_LENGTH);
                gltfHeader = {
                    magic: magic,
                    version: headerDataView.getUint32(4, true),
                    length: headerDataView.getUint32(8, true),
                    contentLength: headerDataView.getUint32(12, true),
                    contentFormat: headerDataView.getUint32(16, true),
                };
                if (gltfHeader.magic != "glTF")
                    throw new viewer_shared_services_1.ShapeDiverViewerDataProcessingError("GLTFLoader.load: Invalid data: sdgTF magic wrong.");
                // create content
                const contentDataView = new DataView(gltfBinary, this.BINARY_EXTENSION_HEADER_LENGTH, gltfHeader.contentLength);
                const contentDecoded = new TextDecoder().decode(contentDataView);
                gltfContent = JSON.parse(contentDecoded);
                // create body
                this._body = gltfBinary.slice(this.BINARY_EXTENSION_HEADER_LENGTH +
                    gltfHeader.contentLength +
                    8, gltfHeader.length);
            }
            else {
                gltfContent = JSON.parse(new TextDecoder().decode(axiosResponse.data));
                const removeLastDirectoryPartOf = (the_url) => {
                    const dir_char = the_url.includes("/") ? "/" : "\\";
                    const the_arr = the_url.split(dir_char);
                    the_arr.pop();
                    return the_arr.join(dir_char);
                };
                gltfBaseUrl = removeLastDirectoryPartOf(url);
                if (!gltfBaseUrl &&
                    window &&
                    window.location &&
                    window.location.href)
                    gltfBaseUrl = removeLastDirectoryPartOf(window.location.href);
            }
            return yield this.load(gltfContent, gltfBinary, gltfHeader, gltfBaseUrl);
        });
    }
    // #endregion Public Methods (2)
    // #region Private Methods (7)
    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
     * @param {number} animationIndex
     * @return {Promise<AnimationClip>}
     */
    loadAnimation(animationId) {
        if (!this._content.animations)
            throw new Error("Animations not available.");
        if (!this._content.animations[animationId])
            throw new Error("Animations not available.");
        const animationDef = this._content.animations[animationId];
        const animationTracks = [];
        let min = Infinity, max = -Infinity;
        for (let i = 0; i < animationDef.channels.length; i++) {
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const path = target.path;
            const node = this._nodes[target.node];
            if (node === undefined)
                throw new Error("Animation node not available.");
            const input = this._accessorLoader.getAccessor(sampler.input);
            min = Math.min(min, input.min[0]);
            max = Math.max(max, input.max[0]);
            const output = this._accessorLoader.getAccessor(sampler.output);
            let interpolation = sampler.interpolation;
            if (interpolation === "CUBICSPLINE") {
                this._logger.warn("Animation with CUBICSPLINE interpolation is currently not supported. Assigning linear interpolation instead.");
                interpolation = "linear";
            }
            animationTracks.push({
                node,
                times: input.array,
                values: output.array,
                path: path,
                interpolation: interpolation === null || interpolation === void 0 ? void 0 : interpolation.toLowerCase(),
            });
        }
        return new viewer_shared_node_tree_1.AnimationData(animationDef.name || "gltf_animation_" + animationId, animationTracks, min, max - min);
    }
    loadCamera(cameraId) {
        if (!this._content.cameras)
            throw new Error("Cameras not available.");
        if (!this._content.cameras[cameraId])
            throw new Error("Cameras not available.");
        const cameraDef = this._content.cameras[cameraId];
        const id = cameraDef.name || "camera_" + cameraId;
        let cameraData;
        if (cameraDef.type === "perspective") {
            const perspectiveCameraDef = cameraDef.perspective;
            cameraData = new viewer_rendering_engine_camera_engine_1.PerspectiveCamera(id);
            cameraData.name = id;
            cameraData.fov = perspectiveCameraDef.yfov * (180 / Math.PI);
            cameraData.aspect = perspectiveCameraDef.aspectRatio || 1;
            cameraData.near = perspectiveCameraDef.znear || 1;
            cameraData.far = perspectiveCameraDef.zfar || 2e6;
        }
        else {
            const orthographicCameraDef = cameraDef.orthographic;
            cameraData = new viewer_rendering_engine_camera_engine_1.OrthographicCamera(id);
            cameraData.name = id;
            cameraData.left = -orthographicCameraDef.xmag;
            cameraData.right = orthographicCameraDef.xmag;
            cameraData.top = -orthographicCameraDef.ymag;
            cameraData.bottom = orthographicCameraDef.ymag;
            cameraData.near = orthographicCameraDef.znear || 1;
            cameraData.far = orthographicCameraDef.zfar || 2e6;
        }
        cameraData.useNodeData = true;
        return cameraData;
    }
    loadLights(lightId) {
        if (!this._content.extensions ||
            !this._content.extensions[GLTF_EXTENSIONS.KHR_LIGHTS_PUNCTUAL] ||
            !this._content.extensions[GLTF_EXTENSIONS.KHR_LIGHTS_PUNCTUAL]
                .lights)
            throw new Error(`Extension ${GLTF_EXTENSIONS.KHR_LIGHTS_PUNCTUAL} not available.`);
        if (!this._content.extensions[GLTF_EXTENSIONS.KHR_LIGHTS_PUNCTUAL]
            .lights[lightId])
            throw new Error("Light not available.");
        const lightDef = this._content.extensions[GLTF_EXTENSIONS.KHR_LIGHTS_PUNCTUAL]
            .lights[lightId];
        const id = lightDef.name || "light_" + lightId;
        let color = "#ffffffff";
        if (lightDef.color !== undefined)
            color = [
                lightDef.color[0] * 255,
                lightDef.color[1] * 255,
                lightDef.color[2] * 255,
            ];
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        let lightData;
        if (lightDef.type === "directional") {
            lightData = new viewer_rendering_engine_light_engine_1.DirectionalLight({ color });
            lightData.name = id;
            const directionalLightData = lightData;
            if (lightDef.intensity !== undefined)
                directionalLightData.intensity = lightDef.intensity;
        }
        else if (lightDef.type === "point") {
            lightData = new viewer_rendering_engine_light_engine_1.PointLight({ color });
            lightData.name = id;
            const pointLightData = lightData;
            pointLightData.distance = range;
            pointLightData.decay = 2;
            if (lightDef.intensity !== undefined)
                lightData.intensity = lightDef.intensity;
            pointLightData.position = [0, 0, 0];
        }
        else if (lightDef.type === "spot") {
            lightData = new viewer_rendering_engine_light_engine_1.SpotLight({ color });
            lightData.name = id;
            lightDef.spot = lightDef.spot || {};
            lightDef.spot.innerConeAngle =
                lightDef.spot.innerConeAngle !== undefined
                    ? lightDef.spot.innerConeAngle
                    : 0;
            lightDef.spot.outerConeAngle =
                lightDef.spot.outerConeAngle !== undefined
                    ? lightDef.spot.outerConeAngle
                    : Math.PI / 4.0;
            const spotLightData = lightData;
            spotLightData.distance = range;
            spotLightData.angle = lightDef.spot.outerConeAngle;
            spotLightData.penumbra =
                1.0 -
                    lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
            spotLightData.decay = 2;
            if (lightDef.intensity !== undefined)
                lightData.intensity = lightDef.intensity;
            spotLightData.position = [0, 0, 0];
            spotLightData.target = [0, 0, -1];
        }
        else {
            throw new Error("Unexpected light type: " + lightDef.type);
        }
        lightData.useNodeData = true;
        return lightData;
    }
    loadNode(nodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._content.nodes)
                throw new Error("Nodes not available.");
            if (!this._content.nodes[nodeId])
                throw new Error("Node not available.");
            const node = this._content.nodes[nodeId];
            const nodeDef = new viewer_shared_node_tree_1.TreeNode(node.name || "node_" + nodeId);
            nodeDef.originalName = node.name;
            this._nodes[nodeId] = nodeDef;
            if (node.matrix) {
                nodeDef.addTransformation({
                    id: "gltf_matrix",
                    matrix: gl_matrix_1.mat4.fromValues(node.matrix[0], node.matrix[1], node.matrix[2], node.matrix[3], node.matrix[4], node.matrix[5], node.matrix[6], node.matrix[7], node.matrix[8], node.matrix[9], node.matrix[10], node.matrix[11], node.matrix[12], node.matrix[13], node.matrix[14], node.matrix[15]),
                });
                nodeDef.addTransformation({
                    id: "gltf_matrix_translation",
                    matrix: gl_matrix_1.mat4.create(),
                });
                nodeDef.addTransformation({
                    id: "gltf_matrix_rotation",
                    matrix: gl_matrix_1.mat4.create(),
                });
                nodeDef.addTransformation({
                    id: "gltf_matrix_scale",
                    matrix: gl_matrix_1.mat4.create(),
                });
            }
            else if (node.translation || node.scale || node.rotation) {
                const matT = node.translation
                    ? gl_matrix_1.mat4.fromTranslation(gl_matrix_1.mat4.create(), gl_matrix_1.vec3.fromValues(node.translation[0], node.translation[1], node.translation[2]))
                    : gl_matrix_1.mat4.create();
                const matS = node.scale
                    ? gl_matrix_1.mat4.fromScaling(gl_matrix_1.mat4.create(), gl_matrix_1.vec3.fromValues(node.scale[0], node.scale[1], node.scale[2]))
                    : gl_matrix_1.mat4.create();
                const matR = node.rotation
                    ? gl_matrix_1.mat4.fromQuat(gl_matrix_1.mat4.create(), gl_matrix_1.vec4.fromValues(node.rotation[0], node.rotation[1], node.rotation[2], node.rotation[3]))
                    : gl_matrix_1.mat4.create();
                nodeDef.addTransformation({
                    id: "gltf_matrix_translation",
                    matrix: matT,
                });
                nodeDef.addTransformation({
                    id: "gltf_matrix_rotation",
                    matrix: matR,
                });
                nodeDef.addTransformation({
                    id: "gltf_matrix_scale",
                    matrix: matS,
                });
            }
            const instanceTransformations = [];
            if (node.extensions &&
                node.extensions[GLTF_EXTENSIONS.EXT_MESH_GPU_INSTANCING]) {
                const ext = node.extensions[GLTF_EXTENSIONS.EXT_MESH_GPU_INSTANCING]
                    .attributes;
                if (ext["TRANSLATION"] && ext["ROTATION"] && ext["SCALE"]) {
                    const translationAttribute = this._accessorLoader.getAccessor(ext["TRANSLATION"]);
                    const rotationAttribute = this._accessorLoader.getAccessor(ext["ROTATION"]);
                    const scaleAttribute = this._accessorLoader.getAccessor(ext["SCALE"]);
                    if (translationAttribute &&
                        rotationAttribute &&
                        scaleAttribute) {
                        const translationMatrices = [];
                        const translationVectors = [];
                        for (let i = 0; i < translationAttribute.array.length; i += 3) {
                            const v = this.getPooledVec3();
                            gl_matrix_1.vec3.set(v, translationAttribute.array[i], translationAttribute.array[i + 1], translationAttribute.array[i + 2]);
                            translationVectors.push(v);
                            translationMatrices.push(gl_matrix_1.mat4.fromTranslation(this.getPooledMatrix(), v));
                        }
                        const rotationMatrices = [];
                        const rotationVectors = [];
                        for (let i = 0; i < rotationAttribute.array.length; i += 4) {
                            const v = this.getPooledVec4();
                            gl_matrix_1.vec4.set(v, rotationAttribute.array[i], rotationAttribute.array[i + 1], rotationAttribute.array[i + 2], rotationAttribute.array[i + 3]);
                            rotationVectors.push(v);
                            rotationMatrices.push(gl_matrix_1.mat4.fromQuat(this.getPooledMatrix(), v));
                        }
                        const scaleMatrices = [];
                        const scaleVectors = [];
                        for (let i = 0; i < scaleAttribute.array.length; i += 3) {
                            const v = this.getPooledVec3();
                            gl_matrix_1.vec3.set(v, scaleAttribute.array[i], scaleAttribute.array[i + 1], scaleAttribute.array[i + 2]);
                            scaleVectors.push(v);
                            scaleMatrices.push(gl_matrix_1.mat4.fromScaling(this.getPooledMatrix(), v));
                        }
                        if (translationMatrices.length ===
                            rotationMatrices.length &&
                            translationMatrices.length === scaleMatrices.length) {
                            for (let i = 0; i < translationMatrices.length; i++) {
                                const transformationMatrix = this.getPooledMatrix();
                                gl_matrix_1.mat4.multiply(transformationMatrix, translationMatrices[i], rotationMatrices[i]);
                                gl_matrix_1.mat4.multiply(transformationMatrix, transformationMatrix, scaleMatrices[i]);
                                instanceTransformations.push(transformationMatrix);
                            }
                            // Return temporary matrices and vectors to pool for reuse
                            for (const mat of translationMatrices)
                                this.returnMatrixToPool(mat);
                            for (const mat of rotationMatrices)
                                this.returnMatrixToPool(mat);
                            for (const mat of scaleMatrices)
                                this.returnMatrixToPool(mat);
                            for (const v of translationVectors)
                                this.returnVec3ToPool(v);
                            for (const v of rotationVectors)
                                this.returnVec4ToPool(v);
                            for (const v of scaleVectors)
                                this.returnVec3ToPool(v);
                        }
                    }
                }
                if (instanceTransformations.length > 0)
                    nodeDef.addData(new viewer_shared_node_tree_1.InstanceData(instanceTransformations));
            }
            if (node.mesh !== undefined) {
                const geometryDataArray = this._geometryLoader.loadMesh(node.mesh, node.weights);
                nodeDef.addData(geometryDataArray);
            }
            if (node.camera !== undefined)
                nodeDef.addData(this.loadCamera(node.camera));
            if (node.extensions &&
                node.extensions[GLTF_EXTENSIONS.KHR_LIGHTS_PUNCTUAL])
                nodeDef.addData(this.loadLights(node.extensions[GLTF_EXTENSIONS.KHR_LIGHTS_PUNCTUAL].light));
            if (node.children) {
                for (let i = 0, len = node.children.length; i < len; i++) {
                    // got through all children
                    nodeDef.addChild(yield this.loadNode(node.children[i]));
                }
            }
            if (node.extras) {
                const customData = new viewer_shared_node_tree_1.CustomData(node.extras);
                nodeDef.data.push(customData);
            }
            this._numberOfConvertedNodes++;
            if (performance.now() - this._progressTimer >
                this._progressUpdateLimit) {
                this._progressTimer = performance.now();
                const eventProgress = {
                    type: viewer_shared_types_1.TASK_TYPE.GLTF_CONTENT_LOADING,
                    id: this._eventId,
                    progress: this._numberOfConvertedNodes / this._numberOfNodes / 2 +
                        0.1,
                    status: `GlTF conversion progress: ${this._numberOfConvertedNodes}/${this._numberOfNodes} nodes.`,
                };
                this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_PROCESS, eventProgress);
            }
            return nodeDef;
        });
    }
    loadScene() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._content.scenes)
                throw new Error("Scenes not available.");
            const sceneId = this._content.scene || 0;
            if (!this._content.scenes[sceneId])
                throw new Error("Scene not available.");
            const scene = this._content.scenes[sceneId];
            const sceneDef = new viewer_shared_node_tree_1.TreeNode(scene.name || "scene_" + sceneId + "");
            sceneDef.originalName = scene.name;
            sceneDef.addTransformation({
                id: this._uuidGenerator.create(),
                matrix: this._globalTransformation,
            });
            if (scene.nodes)
                for (let i = 0, len = scene.nodes.length; i < len; i++)
                    sceneDef.addChild(yield this.loadNode(scene.nodes[i]));
            return sceneDef;
        });
    }
    validateVersionAndExtensions() {
        if (!this._content.asset)
            throw new Error("Asset not available.");
        const asset = this._content.asset;
        if (!asset.version)
            throw new Error("Asset does not have a version.");
        const version = asset.minVersion
            ? asset.minVersion
            : asset.version;
        if (!version.startsWith("2"))
            throw new Error("Version of the glTF not supported.");
        if (this._content.extensionsUsed) {
            const notSupported = [];
            for (let i = 0; i < this._content.extensionsUsed.length; i++) {
                if (!Object.values(GLTF_EXTENSIONS).includes(this._content.extensionsUsed[i]))
                    notSupported.push(this._content.extensionsUsed[i]);
            }
            if (notSupported.length > 0) {
                let message = "Extension" + (notSupported.length === 1 ? " " : "s ");
                notSupported.forEach((element, index) => {
                    message +=
                        '"' +
                            element +
                            '"' +
                            (index === notSupported.length - 1
                                ? ""
                                : index === notSupported.length - 2
                                    ? " and "
                                    : ", ");
                });
                message +=
                    (notSupported.length === 1 ? " is" : " are") +
                        " not supported, but used. Loading glTF regardless.";
                this._logger.info("GLTFLoader.validateVersionAndExtensions: " + message);
            }
        }
        if (this._content.extensionsRequired) {
            const notSupported = [];
            for (let i = 0; i < this._content.extensionsRequired.length; i++) {
                if (!Object.values(GLTF_EXTENSIONS).includes(this._content.extensionsRequired[i]))
                    notSupported.push(this._content.extensionsRequired[i]);
            }
            if (notSupported.length > 0) {
                let message = "Extension" + (notSupported.length === 1 ? " " : "s ");
                notSupported.forEach((element, index) => {
                    message +=
                        '"' +
                            element +
                            '"' +
                            (index === notSupported.length - 1
                                ? ""
                                : index === notSupported.length - 2
                                    ? " and "
                                    : ", ");
                });
                message +=
                    (notSupported.length === 1 ? " is" : " are") +
                        " not supported, but required. Aborting glTF loading.";
                throw new Error(message);
            }
        }
    }
    getPooledMatrix() {
        return this._matrixPool.length > 0
            ? this._matrixPool.pop()
            : gl_matrix_1.mat4.create();
    }
    returnMatrixToPool(matrix) {
        if (this._matrixPool.length < 1000) {
            // Limit pool size to prevent memory bloat
            gl_matrix_1.mat4.identity(matrix);
            this._matrixPool.push(matrix);
        }
    }
    getPooledVec3() {
        return this._vec3Pool.length > 0
            ? this._vec3Pool.pop()
            : gl_matrix_1.vec3.create();
    }
    returnVec3ToPool(v) {
        if (this._vec3Pool.length < 1000) {
            gl_matrix_1.vec3.set(v, 0, 0, 0);
            this._vec3Pool.push(v);
        }
    }
    getPooledVec4() {
        return this._vec4Pool.length > 0
            ? this._vec4Pool.pop()
            : gl_matrix_1.vec4.create();
    }
    returnVec4ToPool(v) {
        if (this._vec4Pool.length < 1000) {
            gl_matrix_1.vec4.set(v, 0, 0, 0, 0);
            this._vec4Pool.push(v);
        }
    }
}
exports.GLTFLoader = GLTFLoader;
//# sourceMappingURL=GLTFLoader.js.map